import { defineStore } from 'pinia';
import state from './state.js';
import getters from './getters.js';
import actions from './actions.js';

const useBusinessStore = defineStore('business', {
	state,
	actions,
	getters,
});

export default useBusinessStore;
